export default "__VITE_ASSET__DixRJXYo__"